import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label, FormGroup, Input } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { getPdfFormList } from "../../../api/workflow";
import { decryptData } from "../../../utils/helper";
import Loader from "../../../components/Loader/Loader";
import { failed, success } from "../../../utils/Tostify";
import TextInput from "../../../components/InputFields/TextInput";
import Uploadform from "../../../assets/images/upload_form.svg";
import { formikAddApplicationForm } from "../Constant";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import { addApplicationForm, createApplicationActivity } from "../../../api/Applications";
import { ActivityDetails } from "../../../utils/constants";
import { useDropzone } from "react-dropzone";

const AddApplicationFormModal = ({ refetch, setShowModal, applicationId, patientId }) => {
    const dispatch = useDispatch();
    let token = useSelector((state) => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFormType, setSelectedFormType] = useState("selectFromList");
    const [selectedForm, setSelectedForm] = useState({});
    const [formList, setFormList] = useState([]);

    const formik = useFormik({
        ...formikAddApplicationForm,
        onSubmit: async (values) => {
            let payload;
            if (values.formType == "selectFromList") {
                payload = {
                    formId: selectedForm._id,
                    formTitle: selectedForm?.formTitle,
                    signer: selectedForm?.signer,
                    state: selectedForm?.state,
                    formFile: selectedForm?.formFile,
                    formType: values?.formType,
                    signatureRequired: values.signatureRequired
                };
            } else {
                let base64pdfForm = "";
                if (values?.pdfForm.name !== undefined) {
                    base64pdfForm = await handleFileUpload(values?.pdfForm);
                    const fileExtension = values?.pdfForm?.type?.split("/")[1];
                    const pdfForm = {
                        base64String: base64pdfForm,
                        extension: fileExtension, // Add the file extension to the object
                        name: values?.pdfForm.name
                    };
                    values.pdfForm = pdfForm;
                }
                payload = {
                    formId: "New",
                    formTitle: values.formTitle,
                    formType: values?.formType,
                    pdfForm: values.pdfForm,
                    signatureRequired: values.signatureRequired
                };
            }
            let res;
            try {
                setIsLoading(true);
                res = await addApplicationForm({ values: payload, dispatch, token, applicationId: applicationId });
                if (res?.status === "SUCCESS") {
                    let values = {
                        type : "Application",
                        event : ActivityDetails?.FormAddEditUpdate?.event,
                        applicationId : applicationId,
                        clinicId: localStorage.getItem("currentHospitalId"),
                        organizationId: localStorage.getItem("currentOrgId"),
                        patientId : patientId ,
                        details : "Application form added."
                      };
                    await createApplicationActivity({ values, dispatch, token });
                    await refetch();
                    success(res.message);
                    setShowModal(false);
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                failed(res?.message);
                setIsLoading(false);
            }
        }
    });

    const handleRadio = (e) => {
        setSelectedFormType(e.target.value);
        formik.setFieldValue("formType", e.target.value);
    };

    const getPdfForms = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getPdfFormList({ dispatch, token, page, limit, searchKey, dataLimit: "all" });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setFormList(responseData);
                setIsLoading(false);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleformSelect = (e) => {
        formik.setFieldValue("formId", e.target.value);
        setSelectedForm(formList.items.find((obj) => obj?._id === e.target.value));
    };

    useEffect(() => {
        getPdfForms(1, 10);
    }, []);

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleRemoveFile = (index) => {
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);
    };

    const onDrop = (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setSelectedFiles([file]);
            formik.setFieldValue("pdfForm", file); // 🟢 Set to Formik
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [] // ✅ Allow only PDF files
        },
        multiple: false // ✅ Only allow one file
    });

    return (
        <Modal isOpen={setShowModal} toggle={setShowModal} size="lg">
            <ModalHeader toggle={setShowModal} className="assign_blk p-0 mb-3">Add Form</ModalHeader>
            <ModalBody className="form-add">
                {isLoading ? <Loader /> : null}
                <Row className="m-0">
                    <Col lg={12} className="location_block mb-3 p-0">
                        <Label>Select Form</Label>
                        <div className="d-flex gap-2">
                            <FormGroup check className="custom-checkbox">
                                Select from List <Input type="radio" id={"radio1"} name={`formRadio`} value={"selectFromList"} onChange={(e) => handleRadio(e)} defaultChecked={true} />
                            </FormGroup>
                            <FormGroup check className="custom-checkbox">
                                Add New <Input type="radio" id={"radio2"} name={`formRadio`} value={"addNew"} onChange={(e) => handleRadio(e)} />
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
               <Row className="m-0">
                    {selectedFormType === "selectFromList" ? (
                        <Col lg={12} className="location_block mb-3 p-0">
                        <TextInput
                            keyField={"formId"}
                            formik={formik}
                            options={formList.items?.map((obj) => ({
                            value: obj?._id,
                            label: obj?.formTitle
                            }))}
                            label="Select Form"
                            type="select"
                            value={formik.values.formId}
                            onChange={(e) => handleformSelect(e)}
                        />
                        </Col>
                    ) : (
                        <Col lg={12} className="location_block mb-3 p-0">
                        {/* 📝 Form Title */}
                        <FormGroup>
                            <TextInput
                            keyField={"formTitle"}
                            formik={formik}
                            label="Form Title"
                            type="text"
                            placeholder="Form Title"
                            value={formik.values.formTitle}
                            onChange={(e) => formik.setFieldValue("formTitle", e.target.value)}
                            />
                        </FormGroup>

                        {/* 📎 Attachment Upload via Drag & Drop */}
                        <Row className="m-0">
                            <Label for="exampleFile">Attachment</Label>
                            <div {...getRootProps()} className="upload-area text-center">
                            <input {...getInputProps()} />
                            <img src={Uploadform} alt="upload" />
                            <p>Drag & drop files here, or click to browse</p>
                            <button type="button" className="browse_blk">Browse</button>
                            </div>
                        </Row>

                        {/* 📄 Uploaded Files Preview */}
                        <Row className="m-0">
                            <Col md={12}>
                            {selectedFiles.length > 0 && (
                                <div className="uploaded-files mt-2">
                                {selectedFiles.map((file, index) => (
                                    <div
                                    key={index}
                                    className="file-item d-flex justify-content-between align-items-center"
                                    >
                                    <p style={{ zIndex: "99" }}>{file.name}</p>
                                    <button
                                        type="button"
                                        className="cancel-btn"
                                        onClick={() => handleRemoveFile(index)}
                                    >
                                        <i className="fas fa-times" />
                                    </button>
                                    </div>
                                ))}
                                </div>
                            )}
                            </Col>
                        </Row>
                        {formik?.errors["pdfForm"] && (
                        <div style={{ color: "red" }}>{formik.errors["pdfForm"]}</div>
                        )}

                        {/* ✅ Signature Required */}
                        <FormGroup className="mt-4">
                            <div className="d-flex justify-content-right gap-4 align-items-center">
                            <Label for="signatureRequired" className="mb-0">
                                Signature Required
                            </Label>
                            <Input
                                id="signatureRequired"
                                name="signatureRequired"
                                type="checkbox"
                                checked={formik.values.signatureRequired}
                                onChange={(e) => formik.setFieldValue("signatureRequired", e.target.checked)}
                            />
                            </div>
                        </FormGroup>
                        </Col>
                    )}
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className="d-flex justify-content-between flex-wrap gap-2">
                    <Button color="secondary" onClick={setShowModal} className="save_btn cancel_btn">
                        Cancel
                    </Button>
                    <Button color="primary" onClick={formik.handleSubmit} className="save_btn"> Save</Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default AddApplicationFormModal;
